import useAppStore from '@/store/app';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function ProjectsLayout() {
  const { setNavigation } = useAppStore();

  useEffect(() => {
    setNavigation(null);
  }, []);

  return <Outlet />;
}
